export const createFocusStyle = ({ semantic: { borderWidth, color }, }) => ({
    outlineWidth: borderWidth.focusWidth.value,
    outlineOffset: borderWidth.focusOffset.value,
    outlineStyle: "solid",
    outlineColor: color.ui.focusRing.value,
});
//# sourceMappingURL=createFocusStyle.js.map